export default "__VITE_ASSET__B21cJCPO__"